import { toast } from "react-toastify";
import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  deleteImageBirthdayStart,
  deleteImageBirthdaySuccess,
  deleteImageBirthdayFailed,
} from "../redux/deleteImageBirthday";
import { setAccountInfo } from "../redux/accountInfo";

import { deleteImageBirthdayApi } from "core/http/service/accountInfo";

function* deleteImageBirthdayWork(
  action: ReturnType<typeof deleteImageBirthdayStart>
) {
  try {
    const res = yield call(deleteImageBirthdayApi, action.payload);

    yield put({
      type: deleteImageBirthdaySuccess.type,
      payload: res,
    });
    // ảnh sinh nhật đã bị xóa => bỏ ảnh cũ khỏi thông tin tài khoản
    yield put({
      type: setAccountInfo.type,
      payload: { avatarBirthday: "" },
    });

    toast.success("Xóa ảnh sinh nhật thành công");
  } catch (error: any) {
    yield put({
      type: deleteImageBirthdayFailed.type,
    });
    toast.error("Xóa ảnh sinh nhật không thành công, vui lòng thử lại");
  }
}

function* watchDeleteImageBirthday() {
  yield takeLatest(deleteImageBirthdayStart.type, deleteImageBirthdayWork);
}

export default function* DeleteImageBirthdaySaga() {
  yield all([watchDeleteImageBirthday()]);
}
